import { useAction, useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import styled from 'styled-components'

import { onboardingDialogsModel } from '@root/app/atoms/reatom-onboarding-dialogs'
import { AutoScaleDialog } from '@root/features/settings/ui/auto-scale-dialog/auto-scale-dialog'
import { Dialog } from '@root/shared/ui-kit'
import { OnboardingDialogAnnouncement } from '@root/widgets/desktop/onboarding-dialog/ui/onboarding-dialog-announcement'

type OnboardingDialogsProps = {}

export const OnboardingDialogs: React.FC<OnboardingDialogsProps> = () => {
  const [acknowledgeDialogOpen] = useAtom(
    onboardingDialogsModel.acknowledgeDialogOpenAtom,
  )
  const [scaleFactorDialogOpen] = useAtom(
    onboardingDialogsModel.scaleFactorDialogOpenAtom,
  )

  const closeAcknowledgeDialog = useAction(
    onboardingDialogsModel.closeAcknowledgeDialogAction,
  )
  const closeScaleFactorDialog = useAction(
    onboardingDialogsModel.closeScaleFactorDialogAction,
  )

  return (
    <>
      <AnimatePresence>
        {acknowledgeDialogOpen ? (
          <Root open describedBy={'acknowledge-dialog'}>
            <OnboardingDialogAnnouncement onClose={closeAcknowledgeDialog} />
          </Root>
        ) : undefined}
        {scaleFactorDialogOpen ? (
          <AutoScaleDialog
            open
            onOpenChange={(open) => {
              if (!open) {
                closeScaleFactorDialog()
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>
    </>
  )
}

const Root = styled(Dialog)`
  width: 400px;
  display: grid;
`
